<!--
    @添加常用系统使用穿梭框
-->
<template>
	<el-dialog 
        title="提示" 
        :visible="visiter" 
        @close="cancel" width="800px" 
        :close-on-click-modal="false" 
        :close-on-press-escape="false"
    >
		<div class="add_system">
			<el-transfer
				style="text-align: left; display: inline-block;"
				v-model="value"
				:props="{
					key: 'id',
					label: 'appName'
				}"
				filterable
				:titles="['源列表', '便捷入口',]"
				:button-texts="['加入左侧', '加入右侧']"
				:format="{
					noChecked: '${total}',
					hasChecked: '${checked}/${total}'
				}"
				@change="handleChange"
				@right-check-change="handleChangeRight"
				:data="data">
			</el-transfer>
			<div class="btns">
				<el-button type="primary" @click="customBtn">自定义添加</el-button>
			</div>
			<div class="btns">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="sure">确定</el-button>
			</div>
			<el-dialog title="添加快捷方式" :visible.sync="visiters" width="500px" append-to-body @close="resetForm('formData')">
				<div class="custom_form">
					<el-form label-width="80px" :model="formData" :rules="rules" ref="formData">
						<el-form-item label="名称：" prop="appName">
							<el-input v-model="formData.appName"></el-input>
						</el-form-item>
						<el-form-item label="网址：" prop="redirectUrl">
							<el-input v-model="formData.redirectUrl"></el-input>
						</el-form-item>
            <el-form-item label="打开方式：" prop="openMod">
                <el-select v-model="formData.openMod" placeholder="请选择">
                    <el-option label="内嵌" value="1"></el-option>
                    <el-option label="路由" value="2"></el-option>
                    <el-option label="新窗口打开" value="9"></el-option>
                </el-select>
            </el-form-item>
					</el-form>
					<div class="btns">
						<el-button @click="customCancel">取消</el-button>
						<el-button type="primary" @click="customSure('formData')">确定</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</el-dialog>
</template>

<script>
import {loadSourceApps,shortCutBatchInsert} from '@/server/new.js';
// import {
//     shortCutBatchInsert,
// } from '@/server/sys';


export default {
	data(){
		return{
			data:[],
			value:[],
			rightList:[],
			chooseList:[],
			formData:{
                appName:'',
                redirectUrl:'',
                openMod: ''
            },
            visiter: false,
			visiters:false,
			rules:{
                appName:[
                    {required:true,message:'请输入名称',trigger:'blur'}
                ],
                redirectUrl:[
                    {required:true,message:'请输入网址',trigger:'blur'}
                ],
                openMod:[
                    {required:true,message:'请选择打开方式',trigger:'blur'}
                ]
            }
		}
	},
	computed:{
        userId: {
            get () { return this.$store.state.user.id }
        },
	},
	methods:{
		apiwbsystemconfiggetSystemConfigList(systemType){ //获取源数据
			let tempFilter={
				systemType:systemType
			}
			if(!systemType){
				delete tempFilter.systemType
			}
            this.visiter = true;
            loadSourceApps().then((res)=>{
                const {data} = res;
                this.dataMap = {}
                data?.forEach(item => {
                    this.dataMap[item.id] = item
                })
                this.data=data;
			})
		},
		handleChange(value, direction, movedKeys) {
			this.rightList=movedKeys;
			// console.log(value, direction, movedKeys);
		},
		handleChangeRight(value, direction, movedKeys){
			this.chooseList=value;
			// console.log(value, direction, movedKeys);
		},
		cancel(){
			this.visiter=false;
			this.$emit('on-close',1);
		},
		sure(){
			if(this.chooseList.length>0||this.rightList.length==0){
				let temp=[];
				for(let item of this.chooseList){
					let tempObj={};
					tempObj.appId=item;
					tempObj.userId=this.userId;
                    tempObj.appName = this.dataMap[item].appName
                    tempObj.redirectUrl = this.dataMap[item].gatewayInfo
					tempObj.openMod=9;
					tempObj.appIcon = this.dataMap[item].appLogo || ''
					temp.push(tempObj)
				}
                shortCutBatchInsert({
                    list: temp
                }).then((res)=>{
                    const {data} = res;
                    if(data.code=='1'){
                        this.$emit('on-close',2);
                        this.visiter=false;
                    }else{
                        this.$alert(data.msg);
                    }
                })
			}else{
				this.$alert('请选择便捷入口');
			}
		},
		// 自定义添加按钮
		customBtn(){
			this.visiters=true;
			this.cancel();
		},
		customCancel(){
			this.visiter=false;
			this.visiters=false;
		},
		customSure(formName){
			this.$refs[formName].validate((valid)=>{
				if(valid){
                    shortCutBatchInsert({
                        list: [{
                        ...this.formData,
                        userId: this.userId
                        }]
                    }).then((response)=>{
						if(response.data.code=='1'){
                            this.$message.success('添加成功');
                            this.$emit('on-close',1);
                            this.customCancel();
						}else{
							this.$message.error(response.dat.msg);
						}
					})
				}else{
					return false;
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
}
</script>

<style lang="less" scoped>
.add_system{
	text-align: center;
	.btns{
		margin-top: 20px;
	}
}
.custom_form{
	.btns{
		text-align: center;
	}
}
</style>
